import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * role:
 *   - "admin" → admins only
 *   - "salesperson" → admin or salesperson (NOT data_entry)
 *   - "data_entry_allowed" → any authenticated user (admin, salesperson, data_entry)
 *   - undefined → any authenticated user
 */
export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-zinc-500">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  if (role === "admin" && user.role !== "admin") {
    return <Navigate to={user.role === "data_entry" ? "/invoices" : "/dashboard"} replace />;
  }
  // salesperson dashboards / stats: blocked for data_entry
  if (role === "salesperson" && user.role === "data_entry") {
    return <Navigate to="/invoices" replace />;
  }
  return children;
}
